
  import {Component, Vue} from 'vue-property-decorator';
  import {ICarList} from '@/modules/CarList/interfaces/car-list.interface';
  import {ICar} from '@/modules/Car/interfaces/car.interface';
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import {IAppState} from "@/interfaces/app-state.interface";
  import {cookieBannerHelper} from "@/shared/CookieBanner/helpers/cookie-banner-helper";

  @Component({})
  export default class TopControls extends Vue {
    selectedSort: ICarList.SortedType = ICarList.SortedType.OwnerByAlphabet;
    sortedList = [
      { id: ICarList.SortedType.OwnerByAlphabet, label: 'По алфавиту' },
      { id: ICarList.SortedType.TimeOnParking, label: 'Время на парковке' },
    ];
    listingDisplayModes = ICarList.ListingDisplayMode;
    available = [
      ICarList.SortedType.OwnerByAlphabet,
      ICarList.SortedType.DaysOnParking,
      ICarList.SortedType.TimeOnParking,
    ];
    get modeButtons() {
      return [
        { mode: ICarList.ListingDisplayMode.Cards, label: 'Режим плиток', icon: 'icon-cards', display: true, },
        { mode: ICarList.ListingDisplayMode.Table, label: 'Режим таблицы', icon: 'icon-table', display: true, },
        { mode: ICarList.ListingDisplayMode.EnterTable, label: 'Режим УК ЖК', icon: 'building', display: this.userAccess.scCarsUnion, },
      ];
    }

    get storeState(): IAppState { return this.$store.state; }
    get carList() { return this.storeState.carList.carList; }
    get easyModeInterface() { return !this.userAccess.extModeFlag; }
    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
    get displayFilters() { return this.storeState.carList.displayFilters; }
    get archiveFlag(): boolean {return this.storeState.carList.currentFilters.fltStatusId === ICar.CarStatusId.Archive};
    set archiveFlag(value) {
      let fltStatusId = value ? ICar.CarStatusId.Archive : null;
      this.$store.commit('carList/setProperty', { name: 'currentFilters', value: { ...this.storeState.carList.currentFilters, fltStatusId } });
    };

    get listingMode() { return this.storeState.carList.activeListingMode; }
    set listingMode(value) {
      let needUpdateList =
        ([this.listingDisplayModes.Cards, this.listingDisplayModes.Table].includes(this.listingMode) && value === this.listingDisplayModes.EnterTable)
      || (this.listingMode === this.listingDisplayModes.EnterTable && [this.listingDisplayModes.Cards, this.listingDisplayModes.Table].includes(value));
      localStorage.setItem(ICarList.LocalStorageKeys.ControlsDisplayMode, value);
      this.$store.commit('carList/setProperty', { name: 'activeListingMode', value });
      if (needUpdateList) this.$store.dispatch('carList/setFilters');
    }

    mounted() {
      this.sortUpdate();
      let sortedBy: any = ICarList.SortedType.OwnerByAlphabet;
      let displayFilters = false;

      if (cookieBannerHelper.cookieConfig.optional) {
        let storageValue = localStorage.getItem(ICarList.LocalStorageKeys.SortedBy);
        sortedBy = storageValue ? storageValue : sortedBy;

        let displayFiltersStorage = localStorage.getItem(ICarList.LocalStorageKeys.DisplayFilters);
        displayFilters = displayFiltersStorage ? JSON.parse(displayFiltersStorage) : displayFilters;
      }

      this.selectedSort = sortedBy;
      this.sortedBy(this.selectedSort);

      this.toggleDisplayFilters(displayFilters);

      window.addEventListener("resize", () => {
        if (document.body.clientWidth < 1054) {
          this.changeDisplayMode(this.listingDisplayModes.Cards);
        }
      });

      if (this.storeState.carList.filters && this.storeState.carList.filters.fltStatusId && this.easyModeInterface) {
        this.archiveFlag = this.storeState.carList.filters.fltStatusId === ICar.CarStatusId.Archive
      }
    }

    sortUpdate() {
      let sortedBy: any = ICarList.SortedType.OwnerByAlphabet;
      if (cookieBannerHelper.cookieConfig.optional) {
        let storageValue = localStorage.getItem(ICarList.LocalStorageKeys.SortedBy);
        sortedBy = storageValue ? storageValue : sortedBy;
      }
      this.$store.commit('carList/setProperty', { name: 'sortDirectionUp', value: true });

      if (sortedBy && this.available.includes(sortedBy)) this.selectedSort = sortedBy;
      else this.selectedSort = ICarList.SortedType.OwnerByAlphabet;

      this.sortedBy(this.selectedSort);
    }

    async openCarPopup(guestActive) {
      if (this.listingMode === this.listingDisplayModes.EnterTable) {
        await this.$store.dispatch('carList/addNewCarUnion');
        return;
      }

      if (!this.userAccess.scCarMk) return;

      await this.$store.dispatch('car/openCarPopup', { carId: null, isGuest: guestActive });
    }

    sortedBy(sortedType: ICarList.SortedType) {
      this.$store.commit('carList/setProperty', { name: 'activeSortedType', value: sortedType });
      localStorage.setItem(ICarList.LocalStorageKeys.SortedBy, sortedType.toString());
    }

    changeDisplayMode(mode: ICarList.ListingDisplayMode) {
      this.listingMode = mode;

      if (mode === ICarList.ListingDisplayMode.Cards) this.sortUpdate();
    }

    async openUploadPopup() {
      await this.$store.dispatch('dialog/openDialog', { blockName: 'carList', dialogName: 'uploadCrsExcel' });
    }

    async displayArchive() {
      this.archiveFlag = !this.archiveFlag;
      await this.$store.dispatch('carList/setFilters');
    }

    async toggleDisplayFilters(value: boolean) {
      this.$store.commit('carList/setProperty', { name: 'displayFilters', value });
      localStorage.setItem(ICarList.LocalStorageKeys.DisplayFilters, JSON.stringify(value));
    }
  }
